import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
    FormControlLabel, Checkbox, FormControl, Button,
    FormGroup, TextField, CircularProgress, makeStyles, Radio, RadioGroup
} from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { dateFormatter } from '../Models/CommonFunc'
import classNames from 'classnames';
import { convertToRaw, EditorState, RichUtils, convertFromHTML, ContentState } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg';
import { newProduct } from '../Models/ProductsModel';
import CheckUserProvider from '../../AllHooks/CheckUserProvider';
import CustomAlert from '../CustomAlert';
import mapValues from 'lodash/mapValues';
import draftToHtml from 'draftjs-to-html';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars'
import { Helmet } from 'react-helmet';
import { getProductDocumentWithUniqueId, updateProductDocument } from '../../Backend/firebase/product';

const useStyles = makeStyles((theme) => ({
    root: {

        '& .MuiFormControlLabel-label.Mui-disabled': {
            color: 'white'
        }
    },
}));

function UpdateProduct({ _id, productId, setOpenPopup }) {
    const classes = useStyles();
    const { register, handleSubmit, errors, reset, setValue } = useForm({
        defaultValues: {
            'Compostions.capsule': false,
            'Compostions.freelance': false
        }
    });
    const [ProductDescription, setProductDescription] = useState(() => EditorState.createEmpty());
    const [openNotify, setOpenNotify] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [ExpiryDate, setExpiryDate] = useState(new Date())
    const [isExpiryDateModified, setIsExpiryDateModified] = useState(false);
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const { userData } = CheckUserProvider();
    const [isEnabledProductSize, setIsEnabledProductSize] = useState(false);

    useEffect(async () => {
        try {
            const getProducts = await getProductDocumentWithUniqueId(productId);
            setTimeout(() => {
                mapValues(getProducts[0], (value, key) => setValue(key, value));
            });
            setExpiryDate(getProducts[0].ExpiryDate);
            setIsEnabledProductSize(getProducts[0]?.ProductSize == "Others" ? true : false)
            setProductDescription(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(draftToHtml(JSON.parse(getProducts[0].ProductDescription))))))
        } catch(error) {
            console.log("Error Occur in Update Product", error)
        }
    }, []);

    const onSubmit = async (data) => {
        setIsLoading(true);
        // if (!isProductEditable) {
            const value = convertToRaw(ProductDescription.getCurrentContent());
            // if (ProductDescription.getCurrentContent().hasText()) {
                newProduct._id = _id;
                newProduct.uniqueId = productId;
                newProduct.userId = userData.uid;
                newProduct.ProductName = data.ProductName;
                newProduct.Compostions = data.Compostions;
                newProduct.PackagingType = data.PackagingType;
                newProduct.ProductType = data.ProductType;
                newProduct.MRP = data.MRP;
                newProduct.PackagingSize = data.ProductSize;
                newProduct.ProductSize = data.ProductSize;
                newProduct.OthersProductSize = isEnabledProductSize ? data.OthersProductSize : '';
                newProduct.HSNCode = data.HSNCode;
                newProduct.GSTClass = data.GSTClass;
                newProduct.Discount = data.Discount;
                if(isExpiryDateModified) {
                    newProduct.ExpiryDate = ExpiryDate;
                }
                newProduct.BatchNo = data.BatchNo;
                newProduct.ProductStatus = data.ProductStatus;
                newProduct.ProductDescription = String(JSON.stringify(value));
                try {
                    var product = updateProductDocument(newProduct);
                    if (product) {
                        setOpenPopup(false);
                        setNotificationMessage('Product Updated successfully.');
                        setOpenNotify(true);
                        setAlertType('success');
                        setIsLoading(false);
                        setTimeout(routeToPages, 2000);
                    } else {
                        setNotificationMessage('Something went wrong, Please try again later!!');
                        setOpenNotify(true);
                        setAlertType('error');
                        setIsLoading(false);
                        history.push('/retailer/create-product');
                    }
                }  catch (error) {
                    console.error(error);
                    setNotificationMessage('Something went wrong, Please try again later!!');
                    setOpenNotify(true);
                    setAlertType('error');
                    setIsLoading(false);
                    history.push('/retailer/create-product');
                }
            // } else {
            //     setNotificationMessage("Please enter product description!");
            //     setOpenNotify(true);
            //     setAlertType('error');
            //     setIsLoading(false);
            // }
        // } else {
        //     setNotificationMessage("This product has not edited yet!!");
        //     setOpenNotify(true);
        //     setAlertType('error');
        //     setIsLoading(false);
        // }
    };

    const routeToPages = () => {
        history.push('/retailer/all-products');
    }

    const onEditorStateChange = (editorState) => {
        setProductDescription(editorState);
    };

    const handleExpiryDateChange = (e) => {
        setExpiryDate(dateFormatter(e.target.value));
        setIsExpiryDateModified(true);
    }

    return (
        <>
            <div className={classes.root}>
                <Helmet>
                    <meta name="description" content="Use this page to update product." />
                    <title>Update Product | Kaipsool Pharmatech</title>
                </Helmet>
                <div className="updateProduct">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">
                            <div className="col-md-6 mb-2">
                                Product Name <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.ProductName })}
                                    name="ProductName" autoComplete="none"
                                    ref={register({ required: 'Please enter product title!' })} />
                                <small className="form-text text-danger">{errors.ProductName && errors.ProductName.message}</small>
                            </div>
                            <div className="col-md-6 mb-2">
                                Compostions <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.Compostions })}
                                    name="Compostions" 
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter product Compostions!' })} />
                            </div>
                            <div className="col-md-4 mb-2">
                                Product Type <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                {/* <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.ProductType })}
                                    name="ProductType" autoComplete="none"
                                    ref={register({ required: 'Please enter Package Type!' })}  /> */}
                                <select 
                                    className={classNames("form-select registerEmp__textbox", { "is-invalid": errors.ProductType })} 
                                    aria-label="Default select example"
                                    name="ProductType" ref={register({
                                        required: 'Please select Product Type!',
                                        validate: {
                                            defaultValue: value => value !== "Select Option" || 'Please select Product Type!'
                                        }
                                    })} defaultValue="Select Product Type" >
                                    <option value="Select Option">Select Option</option>
                                    <option value={'Tablet'}>{'Tablet'}</option>
                                    <option value={'Capsule'}>{'Capsule'}</option>
                                    <option value={'Injection'}>{'Injection'}</option>
                                    <option value={'Powder'}>{'Powder'}</option>
                                    <option value={'Oil'}>{'Oil'}</option>
                                    <option value={'Gel'}>{'Gel'}</option>
                                    <option value={'Capsule'}>{'Capsule'}</option>
                                    <option value={'Ointment'}>{'Ointment'}</option>
                                    <option value={'Syrup'}>{'Syrup'}</option>
                                    <option value={'Cream'}>{'Cream'}</option>
                                    <option value={'Spray'}>{'Spray'}</option>
                                    <option value={'Gelatin'}>{'Gelatin'}</option>
                                    <option value={'Other'}>{'Other'}</option>
                                </select>
                                <small className="form-text text-danger">{errors.ProductType && errors.ProductType.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                Packaging Type <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <select 
                                    className={classNames("form-select registerEmp__textbox", { "is-invalid": errors.PackagingType })} 
                                    aria-label="Default select example"
                                    name="PackagingType" ref={register({
                                        required: 'Please select Packaging Type!',
                                        validate: {
                                            defaultValue: value => value !== "Select Option" || 'Please select Packaging Type!'
                                        }
                                    })} defaultValue="Select Packaging Type" >
                                    <option value="Select Option">Select Option</option>
                                    <option value={'Bottle'}>{'Bottle'}</option>
                                    <option value={'Bucket'}>{'Bucket'}</option>
                                    <option value={'Box'}>{'Box'}</option>
                                    <option value={'Can'}>{'Can'}</option>
                                    <option value={'Drum'}>{'Drum'}</option>
                                    <option value={'Gallon'}>{'Gallon'}</option>
                                    <option value={'Gram'}>{'Gram'}</option>
                                    <option value={'Jar'}>{'Jar'}</option>
                                    <option value={'Kit'}>{'Kit'}</option>
                                    <option value={'Pack'}>{'Pack'}</option>
                                    <option value={'Roll'}>{'Roll'}</option>
                                    <option value={'Set'}>{'Set'}</option>
                                    <option value={'Sample'}>{'Sample'}</option>
                                    <option value={'Strip'}>{'Strip'}</option>
                                    <option value={'Sachet'}>{'Sachet'}</option>
                                    <option value={'Vial'}>{'Vial'}</option>
                                    <option value={'Others'}>{'Others'}</option>
                                </select>
                                <small className="form-text text-danger">{errors.PackagingType && errors.PackagingType.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                Product Size
                                <select 
                                    className={classNames("form-select registerEmp__textbox")} 
                                    aria-label="Default select example"
                                    name="ProductSize" ref={register()} 
                                    onChange={(event)=> {
                                        setIsEnabledProductSize(event.target.value == "Others" ? true : false)
                                    }}
                                    defaultValue="Select Product Size" >
                                    <option value="Select Option">Select Option</option>
                                    <option value={'5ml'}>{'5ml'}</option>
                                    <option value={'10ml'}>{'10ml'}</option>
                                    <option value={'40mg'}>{'40mg'}</option>
                                    <option value={'200gm'}>{'200gm'}</option>
                                    <option value={'Others'}>{'Others'}</option>
                                </select>
                                {isEnabledProductSize && <>
                                    Product Size <small>(if not in list)</small> <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                    <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.OthersProductSize })}
                                        name="OthersProductSize" autoComplete="none"
                                        placeholder="Enter Product Size if not in list"
                                        ref={register({ required: 'Please enter Product Size!' })} />
                                    <small className="form-text text-danger">{errors.OthersProductSize && errors.OthersProductSize.message}</small>
                                </>}
                            </div>
                            <div className="col-md-4 mb-2">
                                MRP <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="number" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.MRP })}
                                    name="MRP" autoComplete="none"
                                    ref={register({ required: 'Please enter product MRP!' })} />
                                    <small className="form-text text-danger">{errors.MRP && errors.MRP.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                Discount(in Percentage) <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="number" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.Discount })}
                                    name="Discount" autoComplete="none"
                                    ref={register({ required: 'Please enter product Discount!' })} />
                                <small className="form-text text-danger">{errors.Discount && errors.Discount.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                GST Class <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <select 
                                    className={classNames("form-select registerEmp__textbox", { "is-invalid": errors.GSTClass })} 
                                    aria-label="Default select example"
                                    name="GSTClass" ref={register({
                                        required: 'Please select GST Class!',
                                        validate: {
                                            defaultValue: value => value !== "Select Option" || 'Please select GST Class!'
                                        }
                                    })} defaultValue="Select GST Class" >
                                    <option value="Select Option">Select Option</option>
                                    <option value={'Nil'}>{'Nil'}</option>
                                    <option value={'5'}>{'5%'}</option>
                                    <option value={'12'}>{'12%'}</option>
                                    <option value={'18'}>{'18%'}</option>
                                    <option value={'28'}>{'28%'}</option>
                                </select>
                                <small className="form-text text-danger">{errors.GSTClass && errors.GSTClass.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                HSN Code
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox")}
                                    name="HSNCode" 
                                    autoComplete="none"
                                    ref={register()} />
                            </div>
                            <div className="col-md-4 mb-2">
                                Batch No <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.BatchNo })}
                                    name="BatchNo" autoComplete="none"
                                    ref={register({ required: 'Please enter product Discount!' })} />
                                <small className="form-text text-danger">{errors.BatchNo && errors.BatchNo.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                Expiry Date <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <DatePickerComponent
                                    id="ExpiryDate"
                                    name="ExpiryDate"
                                    value={ExpiryDate}
                                    cssclassName="e-outline"
                                    onChange={(e) => handleExpiryDateChange(e)}
                                    ref={register({ required: 'Please enter Expiry Date!' })}
                                    format="dd/mm/yyyy"
                                />
                                <small className="form-text text-danger">{errors.ExpiryDate && errors.ExpiryDate.message}</small>
                            </div>
                            <div className="col-md-12 mb-2 mr-3">
                                Product Description
                                <div className="createProduct__RictTextEditor">
                                    <Editor name="ProductDescription" 
                                        editorState={ProductDescription} 
                                        onEditorStateChange={onEditorStateChange}
                                        className="createProduct__editorCss"
                                        toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName" />
                                </div>
                            </div>
                            <div className="col-md-12 mb-3 w-100">
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <div className="p-2">
                                        {/* <Button variant="contained" onClick={() => setIsProductEditable(false)}
                                            style={{ marginRight: '10px' }}>
                                            Edit Product
                                        </Button> */}
                                        <Button type="submit" variant="contained" className="registerEmp__btnLogin">
                                            {isLoading ? <CircularProgress size={18} /> : 'Update Product'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
                notificationMessage={notificationMessage} />
        </>
    )
}

export default UpdateProduct
